import * as React from "react";
const SvgPlatformLogoReddit = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256 256" style={{
  enableBackground: "new 0 0 256 256"
}} xmlSpace="preserve" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path fill="#FF4500" d="M128,0L128,0C57.3,0,0,57.3,0,128l0,0c0,35.4,14.3,67.4,37.5,90.5l-24.4,24.4c-4.8,4.8-1.4,13.1,5.4,13.1H128 l0,0c70.7,0,128-57.3,128-128l0,0C256,57.3,198.7,0,128,0z" /><g><radialGradient id="SVGID_1_" cx={981.0251} cy={1.811} r={127.45} fx={981.0251} fy={-7.319} gradientTransform="matrix(0.47 0 0 -0.41 -260.07 108.3)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.4} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.51} style={{
        stopColor: "#F9FCFC"
      }} /><stop offset={0.62} style={{
        stopColor: "#EDF3F5"
      }} /><stop offset={0.7} style={{
        stopColor: "#DEE9EC"
      }} /><stop offset={0.72} style={{
        stopColor: "#D8E4E8"
      }} /><stop offset={0.76} style={{
        stopColor: "#CCD8DF"
      }} /><stop offset={0.8} style={{
        stopColor: "#C8D5DD"
      }} /><stop offset={0.83} style={{
        stopColor: "#CCD6DE"
      }} /><stop offset={0.85} style={{
        stopColor: "#D8DBE2"
      }} /><stop offset={0.88} style={{
        stopColor: "#EDE3E9"
      }} /><stop offset={0.9} style={{
        stopColor: "#FFEBEF"
      }} /></radialGradient><circle cx={200.6} cy={123.7} r={29.9} fill="url(#SVGID_1_)" /><radialGradient id="SVGID_00000036246770641878814990000005919777119678409602_" cx={672.2592} cy={1.811} r={127.45} fx={672.2592} fy={-7.319} gradientTransform="matrix(0.47 0 0 -0.41 -260.07 108.3)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.4} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.51} style={{
        stopColor: "#F9FCFC"
      }} /><stop offset={0.62} style={{
        stopColor: "#EDF3F5"
      }} /><stop offset={0.7} style={{
        stopColor: "#DEE9EC"
      }} /><stop offset={0.72} style={{
        stopColor: "#D8E4E8"
      }} /><stop offset={0.76} style={{
        stopColor: "#CCD8DF"
      }} /><stop offset={0.8} style={{
        stopColor: "#C8D5DD"
      }} /><stop offset={0.83} style={{
        stopColor: "#CCD6DE"
      }} /><stop offset={0.85} style={{
        stopColor: "#D8DBE2"
      }} /><stop offset={0.88} style={{
        stopColor: "#EDE3E9"
      }} /><stop offset={0.9} style={{
        stopColor: "#FFEBEF"
      }} /></radialGradient><circle style={{
      fill: "url(#SVGID_00000036246770641878814990000005919777119678409602_)"
    }} cx={55.4} cy={123.7} r={29.9} /><radialGradient id="SVGID_00000018938084004212545110000003812637463316940965_" cx={830.6751} cy={-224.6845} r={384.44} gradientTransform="matrix(0.47 0 0 -0.33 -260.07 25.03)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.4} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.51} style={{
        stopColor: "#F9FCFC"
      }} /><stop offset={0.62} style={{
        stopColor: "#EDF3F5"
      }} /><stop offset={0.7} style={{
        stopColor: "#DEE9EC"
      }} /><stop offset={0.72} style={{
        stopColor: "#D8E4E8"
      }} /><stop offset={0.76} style={{
        stopColor: "#CCD8DF"
      }} /><stop offset={0.8} style={{
        stopColor: "#C8D5DD"
      }} /><stop offset={0.83} style={{
        stopColor: "#CCD6DE"
      }} /><stop offset={0.85} style={{
        stopColor: "#D8DBE2"
      }} /><stop offset={0.88} style={{
        stopColor: "#EDE3E9"
      }} /><stop offset={0.9} style={{
        stopColor: "#FFEBEF"
      }} /></radialGradient><ellipse style={{
      fill: "url(#SVGID_00000018938084004212545110000003812637463316940965_)"
    }} cx={128.1} cy={149.3} rx={85.3} ry={64} /><path fill="#842123" d="M102.8,143.1c-0.5,10.8-7.7,14.8-16.1,14.8s-14.8-5.6-14.3-16.4s7.7-18,16.1-18S103.3,132.3,102.8,143.1z" /><path fill="#842123" d="M183.6,141.5c0.5,10.8-5.9,16.4-14.3,16.4s-15.6-3.9-16.1-14.8c-0.5-10.8,5.9-19.6,14.3-19.6 S183.1,130.6,183.6,141.5L183.6,141.5z" /><radialGradient id="SVGID_00000100358442326342623590000001008359023910400391_" cx={-2957.2551} cy={173.4222} r={32.12} gradientTransform="matrix(-0.47 0 0 0.69 -1224.63 31.31)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#FF6600"
      }} /><stop offset={0.5} style={{
        stopColor: "#FF4500"
      }} /><stop offset={0.7} style={{
        stopColor: "#FC4301"
      }} /><stop offset={0.82} style={{
        stopColor: "#F43F07"
      }} /><stop offset={0.92} style={{
        stopColor: "#E53812"
      }} /><stop offset={1} style={{
        stopColor: "#D4301F"
      }} /></radialGradient><path style={{
      fill: "url(#SVGID_00000100358442326342623590000001008359023910400391_)"
    }} d="M153.3,144.1c0.5,10.1,7.2,13.8,15,13.8 s13.8-5.5,13.4-15.7c-0.5-10.1-7.2-16.8-15-16.8S152.8,133.9,153.3,144.1z" /><radialGradient id="SVGID_00000101795553196247918750000016558665307898727865_" cx={745.2351} cy={173.4222} r={32.12} gradientTransform="matrix(0.47 0 0 0.69 -260.07 31.31)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#FF6600"
      }} /><stop offset={0.5} style={{
        stopColor: "#FF4500"
      }} /><stop offset={0.7} style={{
        stopColor: "#FC4301"
      }} /><stop offset={0.82} style={{
        stopColor: "#F43F07"
      }} /><stop offset={0.92} style={{
        stopColor: "#E53812"
      }} /><stop offset={1} style={{
        stopColor: "#D4301F"
      }} /></radialGradient><path style={{
      fill: "url(#SVGID_00000101795553196247918750000016558665307898727865_)"
    }} d="M102.8,144.1c-0.5,10.1-7.2,13.8-15,13.8 s-13.8-5.5-13.3-15.7c0.5-10.1,7.2-16.8,15-16.8S103.3,133.9,102.8,144.1z" /><path fill="#BBCFDA" d="M128.1,165.1c-10.6,0-20.7,0.5-30.1,1.4c-1.6,0.2-2.6,1.8-2,3.2c5.2,12.3,17.6,21,32.1,21s26.8-8.6,32.1-21 c0.6-1.5-0.4-3.1-2-3.2C148.8,165.6,138.7,165.1,128.1,165.1z" /><path fill="#FFFFFF" d="M128.1,167.5c-10.6,0-20.7,0.5-30,1.5c-1.6,0.2-2.6,1.8-2,3.3c5.2,12.5,17.6,21.3,32,21.3s26.8-8.8,32-21.3 c0.6-1.5-0.4-3.1-2-3.3C148.7,168,138.6,167.5,128.1,167.5L128.1,167.5z" /><radialGradient id="SVGID_00000129915728043071345700000001618660102739666578_" cx={826.4651} cy={-508.4764} r={113.26} gradientTransform="matrix(0.47 0 0 -0.31 -260.07 37.28)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#172E35"
      }} /><stop offset={0.29} style={{
        stopColor: "#0E1C21"
      }} /><stop offset={0.73} style={{
        stopColor: "#030708"
      }} /><stop offset={1} style={{
        stopColor: "#000000"
      }} /></radialGradient><path style={{
      fill: "url(#SVGID_00000129915728043071345700000001618660102739666578_)"
    }} d="M128.1,166.2c-10.4,0-20.3,0.5-29.5,1.4 c-1.6,0.2-2.6,1.8-2,3.2c5.2,12.3,17.3,21,31.5,21s26.3-8.6,31.5-21c0.6-1.5-0.4-3.1-2-3.2C148.4,166.8,138.5,166.2,128.1,166.2z" /><radialGradient id="SVGID_00000132773094689987568360000004811110407827195799_" cx={926.3451} cy={277.9019} r={99.42} gradientTransform="matrix(0.47 0 0 -0.47 -260.07 164.72)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.4} style={{
        stopColor: "#FEFFFF"
      }} /><stop offset={0.51} style={{
        stopColor: "#F9FCFC"
      }} /><stop offset={0.62} style={{
        stopColor: "#EDF3F5"
      }} /><stop offset={0.7} style={{
        stopColor: "#DEE9EC"
      }} /><stop offset={0.72} style={{
        stopColor: "#D8E4E8"
      }} /><stop offset={0.76} style={{
        stopColor: "#CCD8DF"
      }} /><stop offset={0.8} style={{
        stopColor: "#C8D5DD"
      }} /><stop offset={0.83} style={{
        stopColor: "#CCD6DE"
      }} /><stop offset={0.85} style={{
        stopColor: "#D8DBE2"
      }} /><stop offset={0.88} style={{
        stopColor: "#EDE3E9"
      }} /><stop offset={0.9} style={{
        stopColor: "#FFEBEF"
      }} /></radialGradient><circle style={{
      fill: "url(#SVGID_00000132773094689987568360000004811110407827195799_)"
    }} cx={174.8} cy={55.5} r={21.2} /><radialGradient id="SVGID_00000093173154653334829310000007940785063173693333_" cx={884.9151} cy={177.5619} r={81.49} gradientTransform="matrix(0.47 0 0 -0.47 -260.07 168.5)" gradientUnits="userSpaceOnUse"><stop offset={0.48} style={{
        stopColor: "#7A9299"
      }} /><stop offset={0.67} style={{
        stopColor: "#172E35"
      }} /><stop offset={0.75} style={{
        stopColor: "#000000"
      }} /><stop offset={0.82} style={{
        stopColor: "#172E35"
      }} /></radialGradient><path style={{
      fill: "url(#SVGID_00000093173154653334829310000007940785063173693333_)"
    }} d="M127.8,88c-2.5,0-4.6-1.1-4.6-2.7 c0-19,15.4-34.4,34.4-34.4c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6c-13.9,0-25.2,11.3-25.2,25.2C132.4,87,130.3,88,127.8,88z" /><path fill="#FF6101" d="M97.3,149.1c0,3.9-4.2,5.7-9.3,5.7s-9.3-1.8-9.3-5.7s4.2-7.1,9.3-7.1S97.3,145.1,97.3,149.1z" /><path fill="#FF6101" d="M177.5,149.1c0,3.9-4.2,5.7-9.3,5.7s-9.3-1.8-9.3-5.7s4.2-7.1,9.3-7.1S177.5,145.1,177.5,149.1z" /><ellipse fill="#FFC49C" cx={94.4} cy={134.8} rx={3.3} ry={3.6} /><ellipse fill="#FFC49C" cx={173.3} cy={134.8} rx={3.3} ry={3.6} /></g></svg>;
export default SvgPlatformLogoReddit;